import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import baoRouter from "./../../services/bao-router";
function ExplorerXlsx(explorerViewModel) {
    var self = this;
    self.GenerateReleaseNote = function () {
        explorerViewModel.TabPage.IsLoading(true);
        var selectedNode = ko.map.toJS(explorerViewModel.SelectedNode(), false, false);
        selectedNode.Nodes = null;
        return Bao.post("SynosetExplorerReport/GenerateReleaseNotes", JSON.stringify({
            explorerTypeId: explorerViewModel.ExplorerTypeId(),
            explorerLayoutId: null,
            explorerFilterId: explorerViewModel.FilterId(),
            node: selectedNode,
            quickFilter: null,
            sorting: explorerViewModel.Sorting(),
            customFilter: null
        }), function (value) {
            explorerViewModel.TabPage.IsLoading(false);
            baoRouter.setHash("#document/" + value);
        });
    };
    self.init = function () {
        return self.GenerateReleaseNote();
    };
}
export default ExplorerXlsx;